module.exports = __webpack_public_path__ + "src/assets/img/sound-white.d9ad8e3a.svg";